import { initialize } from "@workspace/monitoring-web";
initialize();

export { onRouterTransitionStart } from "@workspace/monitoring-web";
